import React, { Component } from 'react';

// const getConfig = (props) => {
//   const { title, imgUrl, cid, vid, color = '#fff', height = 190 } = props;
//   const config = [
//     {
//       name: "Container",
//       props: {
//         width: '95%',
//         padding: 0,
//       },
//       children: [
//         {
//           name: "Image",
//           props: {
//             size: 'large',
//             src: imgUrl,
//             height: `${height}px`,
//             params: {
//               cid,
//               vid,
//             },
//             onClick: 'openView'
//           },
//         },
//         {
//           name: "Text",
//           props: {
//             text: title,
//             position: 'relative',
//             zIndex: 1,
//             color: color,
//             marginTop: '-34px',
//             paddingLeft: '10px',
//           }
//         },
//       ]
//     },

//   ]

//   return config;
// }

export class OneImgWithGap extends Component {

  render() {
    
    const customAttributes = {
    };
    return (
      <div {...this.props} {...customAttributes}>{this.props.children}</div>
    );
  }
}

export default OneImgWithGap;
